import { render, staticRenderFns } from "./CompanySettings.vue?vue&type=template&id=12fab13c&scoped=true&"
import script from "./CompanySettings.vue?vue&type=script&lang=js&"
export * from "./CompanySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fab13c",
  null
  
)

export default component.exports